import { service } from "."

export default {
  getAll: () => service.get("/groups/web"),
  getOne: (id) => service.get(`/groups/web/${id}`),
}
